import type { ReactNode } from 'react';

type Tone = 'default' | 'ok' | 'warn' | 'bad';

interface Props {
  label: string;
  value: ReactNode;
  details?: ReactNode;
  tone?: Tone;
  className?: string;
}

export default function MetricTile({
  label,
  value,
  details,
  tone = 'default',
  className = '',
}: Props) {
  const toneClass =
    tone === 'ok'
      ? 'ui-metric-tile--ok'
      : tone === 'warn'
        ? 'ui-metric-tile--warn'
        : tone === 'bad'
          ? 'ui-metric-tile--bad'
          : '';

  return (
    <div className={`ui-metric-tile ui-metric-tile--${tone} ${toneClass} ${className}`.trim()}>
      <div className="text-[10px] uppercase tracking-[1.5px] text-dim">{label}</div>
      <div className="text-xl leading-tight font-semibold">{value}</div>
      {details && <div className="text-xs text-muted">{details}</div>}
    </div>
  );
}
